var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.956 20.555",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#999;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M587.487,274.518a6.987,6.987,0,1,1-3.532-6.055q.487-.621.976-1.217a8.518,8.518,0,1,0,2.222,1.944q-.452.674-.9,1.379A6.929,6.929,0,0,1,587.487,274.518Z",
    transform: "translate(-572.001 -262.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M591.525,261.455a45.508,45.508,0,0,0-3.491,3.564c-1.4,1.582-2.71,3.24-3.955,4.947-.952,1.312-1.863,2.634-2.737,4.012l-2.657-2.471-1.936,2.418,4.1,2.808,1.206.825.574-1.2c.871-1.82,1.875-3.652,2.922-5.423s2.18-3.511,3.4-5.182a44.534,44.534,0,0,1,3.078-3.8Z",
    transform: "translate(-573.073 -261.455)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.820232f4c8bd8ea3b6ef9e4440132a1a.svg";
export { ForwardRef as ReactComponent };